<template>
  <div class="download-form">
    <h2>Download template</h2>
    <input
      v-model="email"
      type="email"
      placeholder="Enter your email"
    />

    <button @click="download">
      <i class="fas fa-download"></i> Download
    </button>
    <p>Note: Các bước hướng dẫn định giá doanh nghiệp được ghi chú trong template</p>
    <p v-if="message">{{ message }}</p>
  </div>
</template>

<script setup>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "templates",
  computed: {
    ...mapGetters({
      form: 'templates/form',
      downloadUrl: 'templates/downloadUrl',
    }),
  },
  methods: {
    ...mapActions({
      downloadTemplate: 'templates/downloadTemplate',
    }),
    download() {
      if (this.email) {
        console.log(this.email);
        this.downloadTemplate(this.email);
        console.log(this.downloadUrl);
        if (this.downloadUrl) {
          window.location.href = this.downloadUrl;
          message.value = "Download started.";
        }
      }
    }
  },
}
</script>